var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3498 0.650536C15.0568 0.355364 14.6862 0.149232 14.2809 0.0560113C13.8756 -0.0372093 13.4521 -0.0137046 13.0596 0.123803L1.83532 4.00591C1.25039 4.20816 0.770218 4.57629 0.444286 5.07247C0.145798 5.5353 -0.00868807 6.07627 0.000377272 6.62693C0.00944261 7.17758 0.181652 7.71318 0.495213 8.16593C0.838606 8.65047 1.33041 9.00405 1.92116 9.18593L4.41222 9.95566C4.57499 10.0063 4.74853 10.0114 4.914 9.97037C5.07946 9.92933 5.23051 9.84372 5.35073 9.72285L7.34997 7.72359C7.47288 7.60068 7.63958 7.53163 7.8134 7.53163C7.98722 7.53163 8.15392 7.60068 8.27684 7.72359C8.39975 7.8465 8.4688 8.01321 8.4688 8.18703C8.4688 8.36085 8.39975 8.52755 8.27684 8.65046L6.27759 10.6497C6.15672 10.7699 6.07111 10.921 6.03007 11.0865C5.98903 11.2519 5.99411 11.4255 6.04478 11.5882L6.81451 14.0793C6.99639 14.6701 7.34997 15.1619 7.8345 15.5053C8.28611 15.8215 8.82268 15.9939 9.37395 16H9.42051C9.95566 16.0018 10.4797 15.847 10.9279 15.5547C11.4241 15.2288 11.7922 14.7486 11.9945 14.1637L15.8766 2.93935C16.0138 2.54702 16.0371 2.12387 15.9439 1.71883C15.8507 1.3138 15.6447 0.943417 15.3498 0.650536Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.e257204a32ccdb77530c2ccc549b0f96.svg";
export { ForwardRef as ReactComponent };